import React from 'react';

export default {
  svg: (
    <g>
      <path d="M195.56,152.17a16.16,16.16,0,0,0-22.84,0l-8.66,8.66L139,135.77l8.67-8.67h0a16.17,16.17,0,0,0,0-22.83L116.87,73.48a16.16,16.16,0,0,0-22.84,0,59.76,59.76,0,0,0,0,84.41l47.9,47.91a59.76,59.76,0,0,0,84.42,0,16.17,16.17,0,0,0,0-22.83Zm20.18,43a44.75,44.75,0,0,1-63.2,0l-47.9-47.91a44.72,44.72,0,0,1,0-63.19,1.16,1.16,0,0,1,1.62,0l30.79,30.78a1.19,1.19,0,0,1,0,1.63l-19.27,19.27L164.06,182l19.27-19.26a1.16,1.16,0,0,1,1.62,0l30.79,30.78A1.19,1.19,0,0,1,215.74,195.19Z" />
    </g>
  ),
  viewBox: '0 0 300 300'
};
